import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Lublin() {
  return (
    <>
      <DisplayMaster voivodeship="Lublin" />
    </>
  );
}